// src/api/apiClient.js
import axios from "axios";
import { AuthAPI } from "./modules/auth.api";
import Cookies from "js-cookie";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

let isValidatingClient = false;
let pendingRequests = [];

apiClient.interceptors.request.use(
  async function (config) {
    let clientToken = Cookies.get("clientToken");
    let clientRefreshToken = Cookies.get("clientRefreshToken");
    if (!clientToken && !isValidatingClient) {
      isValidatingClient = true;

      try {
        const response = await AuthAPI.validateClient();
        clientToken = response.data.data.accessToken;
        clientRefreshToken = response.data.data.refreshToken;

        const expiresInHours = 5 / 24;
        Cookies.set("clientToken", clientToken, {
          expires: expiresInHours,
          // secure: true,
        });

        Cookies.set("clientRefreshToken", clientRefreshToken, {
          expires: expiresInHours,
          // secure: true,
        });

        pendingRequests.forEach((cb) => cb());
        pendingRequests = [];
      } catch (err) {
        console.error("Failed to validate client:", err);
        return Promise.reject(err);
      } finally {
        isValidatingClient = false;
      }
    } else if (!clientToken && isValidatingClient) {
      return new Promise((resolve) => {
        pendingRequests.push(() => resolve(apiClient(config)));
      });
    }

    // // Attach tokens
    if (clientToken) {
      config.headers["Authorization"] = `Bearer ${clientToken}`;
    }

    const accountToken = Cookies.get("webapitoken");
    if (accountToken) {
      config.headers["webapitoken"] = accountToken;
    }

    // // Content-Type handling
    if (config.data instanceof FormData || config.data === null) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    // console.log("CONFIG: ", config);

    return config;
  },
  function (error) {
    console.log("ERROR: ", error);
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized - redirecting to login...");
      // window.location.href = "/login";
    }
    if (error.response?.status >= 500) {
      console.error("Server error:", error.response);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
